import React from 'react';

/** A small "?" hint icon that reveals an instructional tooltip on hover/focus.
 * Unlike IconButton's tooltip (short, single-line labels), this wraps longer
 * multi-sentence text, so it needs a fixed width instead of whitespace-nowrap. */
export default function InfoTooltip({ text, position = 'top', className = '' }) {
  const positionClasses = position === 'bottom' ? 'top-full mt-2' : 'bottom-full mb-2';

  return (
    <span className={`relative inline-flex group ${className}`}>
      <span
        tabIndex={0}
        role="button"
        aria-label={text}
        className="w-4 h-4 shrink-0 flex items-center justify-center rounded-full bg-gray-400 hover:bg-gray-500 text-white text-[10px] font-bold cursor-help focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-300"
      >
        ?
      </span>
      <span
        role="tooltip"
        className={`pointer-events-none absolute ${positionClasses} left-1/2 -translate-x-1/2 w-72 whitespace-normal px-3 py-2 rounded-md bg-gray-900 text-white text-xs leading-relaxed opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 group-focus-within:opacity-100 transition duration-150 z-30`}
      >
        {text}
      </span>
    </span>
  );
}
